import React from "react";

import Badge, { BadgeProps } from "antd/es/badge";

import Colored from "@mapmycustomers/shared/types/base/Colored";
import Named from "@mapmycustomers/shared/types/base/Named";
import anyColorToHex from "@mapmycustomers/shared/util/color/anyColorToHex";

import colors from "@app/styles/_colors.module.scss";

interface Props {
  className?: string;
  entity: Colored & Named;
  hideName?: boolean;
  size?: BadgeProps["size"];
  textColor?: string;
}

const EntityBadge = ({ className, entity, hideName, textColor, ...props }: Props) => {
  const color = textColor ? textColor : entity.color ? anyColorToHex(entity.color) : colors.slate;

  return (
    <Badge className={className} color={color} text={hideName ? "" : entity.name} {...props} />
  );
};

export default EntityBadge;
